import React, { useEffect, useState } from "react";
// import { app, auth } from "./firebase";
// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import "firebase/compat/messaging";
import { getMessaging, getToken } from "firebase/messaging";
import "firebase/compat/analytics";
import { Capacitor } from '@capacitor/core';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB8YeifobKfJJSO3nselAILteDgp4iIAMA",
    authDomain: "loginwithphone-9fb64.firebaseapp.com",
    projectId: "loginwithphone-9fb64",
    storageBucket: "loginwithphone-9fb64.appspot.com",
    messagingSenderId: "395072549821",
    appId: "1:395072549821:web:4f59770be42fda341a98d4",
    measurementId: "G-RWZEXW6VMP",
    databaseURL: "https://loginwithphone-9fb64.firebaseio.com/"
};

// Initialize Firebase
firebase.apps.length ? firebase.app() : firebase.initializeApp(firebaseConfig);

const db = firebase.database(); 
// console.log(db)

export const analytics = firebase.analytics()
// analytics.logEvent('add_to_cart')


let messaging = null;

if (Capacitor.getPlatform() === 'web' && 'serviceWorker' in navigator) {
  messaging = firebase.messaging();
}

export { messaging };
// export const messaging = firebase.messaging()

export const inappmessage = {
    notification: {
        title: 'Someone from pune just buying organic products',
        body: 'Go organic. Buy with exclusive offer on each an every collection of organic items.'
    },
    webpush: {
        fcm_options: {
            link: "https://triokzz.com"
        }
    }
};

export const generateToken = async () => {
  try {
    if ('Notification' in window) {
        const permission = await Notification.requestPermission();
        console.log(permission)
        if (permission === 'granted') {
            console.log('Notification permission granted.');
            const token = await messaging.getToken({ vapidKey: 'BHxb8L5RKKlyVfHRdCBznzfa7Z7pxB-mPXbaUDnxaLFovUxZZuHyEpa3bni3ALXlfAzvjYwQU0Bi9g6Kl1TB7QU' })
            // console.log('FCM Token:', token);
        } else {
            console.log('Notification permission denied.');
        }
    }
  }  catch (err) {
    console.error('Error in generateToken():', err);
  }
     
    // if ('Notification' in window) {
    //      Notification && Notification.requestPermission() && Notification.requestPermission().then((permission) => {
    //         if (permission === 'granted') {
    //             console.log('Notification permission granted.');
    //             const token = messaging.getToken({ vapidKey: 'BHxb8L5RKKlyVfHRdCBznzfa7Z7pxB-mPXbaUDnxaLFovUxZZuHyEpa3bni3ALXlfAzvjYwQU0Bi9g6Kl1TB7QU' })
    //             return token
    //         }
    //     })
    // }
}


// messaging.onBackgroundMessage((payload) => {
//     console.log('[firebase-messaging-sw.js] Received background message ', payload)
//     const notificationTitle = payload.notification.title
//     const notificationOptions = {
//         body: payload.notification.body,
//         icon: payload.notification.icon || payload.notification.image,
//     }

//     self.registration.showNotification(notificationTitle, notificationOptions)
// })

export function FirebaseViewers() {
    const [viewers, setViewers] = useState(26);
  
    useEffect(() => {
      // 3. Use v8 legacy pathing and chaining methods
      const connectionsRef = db.ref('connections');
      const connectedRef = db.ref('.info/connected');
  
      let myConnectionsRef = null;
  
      // Monitor connection state
      connectedRef.on('value', (snap) => {
        // console.log("Is Connected:", snap.val());
        if (snap.val() === true) {
          // Generate a unique reference for this specific user
          myConnectionsRef = connectionsRef.push();
          myConnectionsRef.set(true);
  
          // Remove this user when they disconnect or close the tab
          myConnectionsRef.onDisconnect().remove();
        }
      });
      // console.log("Is Connected:",connectionsRef);
      // Listen for total active count changes
      connectionsRef.on('value', (snap) => {
        // console.log("Is Connected:", snap.numChildren());
        // numChildren() returns total active keys
        setViewers(snap.numChildren()); 
      });
  
      // Cleanup listeners when component unmounts
      return () => {
        connectedRef.off();
        connectionsRef.off();
        if (myConnectionsRef) {
          myConnectionsRef.remove();
        }
      };
    }, []);
  
    return (
      <div style={{ padding: '10px',  borderRadius: '5px' }} className='float-left bg-violet-700 text-white text-xs font-medium mr-2 px-1.5 py-1'>
        👁️ <strong> 
        {viewers * 2}</strong> viewing now.
      </div>
    );
  }